import React, { memo } from 'react';
import PropTypes from 'prop-types';
import dynamic from 'next/dynamic';
import { COMPLETED_PROFILE_SECTIONS_NAMES, TP } from '../../../../constants/consts';
import { EditLayout } from '../../../../components/EditComponents/EditLayout';
import { checkCompletion } from '../../../../utils/editCommon';

const CompanyBasicInfo = dynamic(import('./components/CompanyBasicInfo'));
const CompanyContacts = dynamic(import('./components/CompanyContacts'));
const DigitalPresence = dynamic(import('./components/DigitalPresence'));
const Staff = dynamic(import('./components/Staff'));
const CompanyVenues = dynamic(import('./components/CompanyVenues'));
// const Video = dynamic(import('./components/Video'));
const Images = dynamic(import('./components/Images'));
// const Press = dynamic(import('./components/Press'));

const tabValues = {
  basic: 'basic',
  contacts: 'contacts',
  digital: 'digital',
  staff: 'staff',
  venues: 'venues',
  // video: 'video',
  images: 'images',
  // press: 'press',
};

export function EditCompany({ company, privacyOptions }) {
  const completedSections = company?.completedSections || [];

  const tabs = {
    [tabValues.basic]: {
      value: tabValues.basic,
      name: `${TP}.FN_BASIC_INFO_TITLE`,
      title: `${TP}.FN_BASIC_INFO_TITLE`,
      subtitle: `${TP}.FN_BASIC_INFO_SUBTITLE`,
      form: <CompanyBasicInfo goToNextTab={() => goToTab(tabValues.contacts)} />,
      isFilled: checkCompletion(completedSections, COMPLETED_PROFILE_SECTIONS_NAMES.BASIC_INFORMATION),
    },
    [tabValues.contacts]: {
      value: tabValues.contacts,
      name: `${TP}.FN_CONTACT_INFO_TITLE`,
      title: `${TP}.FN_CONTACT_INFO_TITLE`,
      subtitle: `${TP}.FN_CONTACT_INFO_SUBTITLE`,
      form: <CompanyContacts goToNextTab={() => goToTab(tabValues.digital)} />,
      isFilled: checkCompletion(completedSections, COMPLETED_PROFILE_SECTIONS_NAMES.CONTACTS),
    },
    [tabValues.digital]: {
      value: tabValues.digital,
      name: `${TP}.FN_EDIT_ARTIST_PROFILE_DIGITAL_TAB`,
      title: `${TP}.FN_EDIT_ARTIST_PROFILE_DIGITAL_TAB`,
      subtitle: `${TP}.FN_DIGITAL_PRESENCE_SUBTITLE`,
      form: (
        <DigitalPresence
          company={company}
          goToNextTab={() => goToTab(tabValues.staff)}
          privacyOptions={privacyOptions}
        />
      ),
      isFilled: checkCompletion(completedSections, COMPLETED_PROFILE_SECTIONS_NAMES.DIGITAL_PRESENCE),
    },
    [tabValues.staff]: {
      value: tabValues.staff,
      name: `${TP}.FN_STAFF_TITLE`,
      form: <Staff company={company} goToNextTab={() => goToTab(tabValues.venues)} privacyOptions={privacyOptions} />,
      isFilled: checkCompletion(completedSections, COMPLETED_PROFILE_SECTIONS_NAMES.MANAGEMENT_STAFF),
    },
    [tabValues.venues]: {
      value: tabValues.venues,
      name: `${TP}.m_VENUES`,
      form: <CompanyVenues company={company} goToNextTab={() => goToTab(tabValues.images)} />,
      isFilled: checkCompletion(completedSections, COMPLETED_PROFILE_SECTIONS_NAMES.VENUES),
    },
    // [tabValues.video]: {
    //   value: tabValues.video,
    //   name: `${TP}.m_VIDEO`,
    //   title: `${TP}.FN_VIDEO_TITLE`,
    //   subtitle: `${TP}.FN_EDIT_ARTIST_PROFILE_VIDEO_SUBTITLE`,
    //   form: <Video goToNextTab={() => goToTab(tabValues.images)} />,
    //   isFilled: false,
    // },
    [tabValues.images]: {
      value: tabValues.images,
      name: `${TP}.m_IMAGES`,
      form: <Images company={company} goToNextTab={() => goToTab(tabValues.basic)} />,
      isFilled: checkCompletion(completedSections, COMPLETED_PROFILE_SECTIONS_NAMES.IMAGES),
    },
    // [tabValues.press]: {
    //   value: tabValues.press,
    //   name: `${TP}.FN_PRESS_TITLE`,
    //   title: `${TP}.FN_PRESS_TITLE`,
    //   subtitle: `${TP}.FN_EDIT_ARTIST_PROFILE_REVIEWS_SUBTITLE`,
    //   form: <Press />,
    //   isFilled: false,
    // },
  };

  const [selectedTab, selectTab] = React.useState(tabs[tabValues.basic]);

  const goToTab = tabName => {
    selectTab(tabs[tabName]);
  };

  return <EditLayout tabs={tabs} selectedTab={selectedTab} goToTab={goToTab} />;
}
EditCompany.propTypes = {
  company: PropTypes.object,
};

EditCompany.defaultProps = {
  company: {},
};

export default memo(EditCompany);
